import {
  AILIST_ATTEMPT,
  AIACTION_ATTEMPT,
  AI_ERROR,
  FETCHALLAIRUNS_SUCCESS,
  FETCHAIRUN_ATTEMPT,
  FETCHAIRUN_SUCCESS,
  ADDAIRUN_SUCCESS,
  DELETEAIRUN_SUCCESS,
  ARCHIVEAIRUN_SUCCESS,
  RESTOREAIRUN_SUCCESS,
  FETCHAISETTINGS_SUCCESS,
  UPDATEAISETTINGS_SUCCESS,
  ADDAIMESSAGE_SUCCESS,
  FETCHAIASSETS_SUCCESS,
  ADDAIASSET_SUCCESS,
  DELETEAIASSET_SUCCESS,
  UPDATEAIASSET_SUCCESS,
  GENERATE_VIDEO_SUCCESS,
  FETCH_GIF_QUEUE_SUCCESS,
  ADD_GIF_QUEUE_SUCCESS,
  DELETE_GIF_QUEUE_SUCCESS,
  FETCHAILIBRARYASSETS_SUCCESS,
  SAVEAILIBRARYASSET_SUCCESS,
  DELETEAILIBRARYASSET_SUCCESS,
  UPDATE_RUN_DRAFT,
  REFRESHAIRUN_SUCCESS,
} from '../constants';

const initialState = {
  fetching: false,
  actionLoading: false,
  runs: null,
  run: null,
  settings: null,
  assets: null,
  libraryAssets: null,
  gifQueue: null,
  requestedRunId: null,
  currentRunId: null,
  error: null,
  drafts: {},
  emptyRuns: {},
};

export default function ai(state = initialState, action) {
  switch (action.type) {
    case AILIST_ATTEMPT:
      return { ...state, fetching: true, error: null };
    case FETCHAIRUN_ATTEMPT:
      return {
        ...state,
        fetching: true,
        run: null,
        requestedRunId: action.payload.id,
        currentRunId: action.payload.id,
        error: null,
      };
    case AIACTION_ATTEMPT:
      return { ...state, actionLoading: true, error: null };
    case AI_ERROR:
      if (
        action.meta?.requestedRunId &&
        action.meta.requestedRunId !== state.currentRunId
      ) {
        return state;
      }
      return {
        ...state,
        error: action.payload,
        fetching: false,
        actionLoading: false,
        requestedRunId: action.meta?.requestedRunId ? null : state.requestedRunId,
      };
    case FETCHALLAIRUNS_SUCCESS:
      return { ...state, fetching: false, runs: action.payload.data };
    case FETCHAIRUN_SUCCESS:
      if (
        action.payload.requestedRunId &&
        action.payload.requestedRunId !== state.currentRunId
      ) {
        return state;
      }
      return {
        ...state,
        fetching: false,
        actionLoading: false,
        run: action.payload.run,
        requestedRunId: null,
      };
    case REFRESHAIRUN_SUCCESS:
      // Silent refresh: update the run without touching fetching/requestedRunId
      return {
        ...state,
        run: action.payload.run,
      };
    case ADDAIRUN_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        run: action.payload.run,
        emptyRuns: {
          ...state.emptyRuns,
          [action.payload.run._id]: action.payload.run,
        },
      };
    case UPDATE_RUN_DRAFT: {
      const { runId, prompt } = action.payload;
      return {
        ...state,
        drafts: {
          ...state.drafts,
          [runId]: prompt,
        },
      };
    }
    case DELETEAIRUN_SUCCESS:
    case ARCHIVEAIRUN_SUCCESS:
    case RESTOREAIRUN_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        runs: state.runs
          ? {
            ...state.runs,
            docs: (state.runs.docs || []).filter(
              (doc) => doc._id !== action.payload
            ),
          }
          : state.runs,
      };
    case ADDAIMESSAGE_SUCCESS:
    case GENERATE_VIDEO_SUCCESS: {
      const newDrafts = { ...state.drafts };
      if (action.payload.run) delete newDrafts[action.payload.run._id];
      return {
        ...state,
        actionLoading: false,
        run: action.payload.run,
        drafts: newDrafts,
      };
    }
    case FETCHAIASSETS_SUCCESS:
      return { ...state, fetching: false, assets: action.payload.assets };
    case ADDAIASSET_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        assets: state.assets
          ? {
            ...state.assets,
            docs: [action.payload.asset, ...(state.assets.docs || [])],
          }
          : state.assets,
      };
    case DELETEAIASSET_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        assets: state.assets
          ? {
            ...state.assets,
            docs: (state.assets.docs || []).filter(
              (doc) => doc._id !== action.payload.id
            ),
          }
          : state.assets,
      };
    case UPDATEAIASSET_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        assets: state.assets
          ? {
            ...state.assets,
            docs: (state.assets.docs || []).map((doc) =>
              doc._id === action.payload.asset._id ? action.payload.asset : doc
            ),
          }
          : state.assets,
      };
    case FETCHAISETTINGS_SUCCESS:
    case UPDATEAISETTINGS_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        settings: action.payload.settings,
      };
    case FETCH_GIF_QUEUE_SUCCESS:
      return { ...state, fetching: false, actionLoading: false, gifQueue: action.payload.data };
    case ADD_GIF_QUEUE_SUCCESS: {
      if (!state.gifQueue) return state;
      const existingIndex = (state.gifQueue.docs || []).findIndex(doc => doc._id === action.payload.job._id);
      let newDocs = [...(state.gifQueue.docs || [])];
      if (existingIndex >= 0) {
        newDocs[existingIndex] = action.payload.job;
      } else {
        newDocs = [action.payload.job, ...newDocs];
      }
      return {
        ...state,
        actionLoading: false,
        gifQueue: {
          ...state.gifQueue,
          docs: newDocs,
        },
      };
    }
    case DELETE_GIF_QUEUE_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        gifQueue: state.gifQueue
          ? {
            ...state.gifQueue,
            docs: (state.gifQueue.docs || []).filter(
              (doc) => doc._id !== action.payload
            ),
          }
          : state.gifQueue,
      };
    case FETCHAILIBRARYASSETS_SUCCESS:
      return { ...state, fetching: false, libraryAssets: action.payload.assets };
    case SAVEAILIBRARYASSET_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        libraryAssets: state.libraryAssets
          ? {
            ...state.libraryAssets,
            docs: [action.payload.asset, ...(state.libraryAssets.docs || [])],
          }
          : state.libraryAssets,
      };
    case DELETEAILIBRARYASSET_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        libraryAssets: state.libraryAssets
          ? {
            ...state.libraryAssets,
            docs: (state.libraryAssets.docs || []).filter(
              (doc) => doc._id !== action.payload
            ),
          }
          : state.libraryAssets,
      };
    default:
      return state;
  }
}

